module.exports = __webpack_public_path__ + "static/about-us-our-specialists-photo@2x-e889a8679703610255dccc1e8ae4a101.jpg";